import React from "react";
import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import { useGetAllOffersQuery } from "../../Store/Services/OfferService";
import styles from "./Offers.module.css";

const Offers = () => {
  const { data: offers, isSuccess } = useGetAllOffersQuery();

  if (!isSuccess || !offers) return null;

  return (
    <div className={styles.outerContainer}>


      <div className={styles.container}>
        {offers.map((data) => (
          <div key={data.offerId} className={styles.cardWrapper}>
            <Link to={`/checkout/offer?id=${data.parentCatUuid}`}>
              <div className={styles.cardContainer}>
                <Typography className={styles.off} variant="h2">
                  {Math.trunc(data.off)}%
                </Typography>
                <Typography className={styles.offTitle} variant="h3">
                  {data.offerDesc}
                </Typography>
                <Button className={styles.button} variant="contained">
                  Check it out
                </Button>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Offers;
